<template>
  <div class="sidebar">
    <h4>News</h4>
    <p>
      <strong>Please Note: Make sure pop ups are enabled for login to the PEA system.</strong>
    </p>
    <p>
      Click here to see <a href="updates">Recent Updates to PEA</a>.
    </p>
    <h4>Resources</h4>
    <p>
      Questions on application functionality? Check the <a href="https://home.teleflex.com/Intranet/TeleflexIncorporated/PEADocumentation/"  target="_blank">Help Documentation</a>.
    </p>
    <p>
      General questions about the PEA process? Check the <a href="https://home.teleflex.com/Intranet/TeleflexIncorporated/PEADocumentation/faq.html" target="_blank">PEA FAQ</a>.
    </p>
    <p>
      For any general feedback, problems, issues, or questions, please contact the Service Desk by e-mail at <a href="mailto:servicedesk@teleflex.com">servicedesk@teleflex.com</a> or by phone at +1 (855) 848-3375.
    </p>
  </div>
</template>

<script>
export default {
  name: 'left-link-component'
}
</script>
<style scoped>

.sidebar {
  background: linear-gradient(to right, #ffffff 95%,#ffffff 95%,#f5f5f5 100%);
  padding-top: 15px;
  position: relative;
  padding-right: 25px;
}

h4 {
  background: #00a9ce;
  color: white;
  padding: 6px 13px 6px 13px;
  margin-left: -23px;
  margin-right: -5px;
  border-radius: 5px;
  margin-bottom: 25px;
}

hr {
  margin: 10px 0;
  border-width: 1px !important;
}

p {
  font-size: .9em;
}

.sidebar:before {
  content: '';
  display: block;
  width: 5%;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
}

.sidebar:after {
  content: '';
  display: block;
  width: 5%;
  height: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  background: linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
}

@media (max-width: 991px){

  .sidebar {
    background: none;
    padding-right: 15px;
    margin-bottom: 25px;
  }

  .sidebar:before, .sidebar:after {
    display: none;
  }

  h4 {
    margin-right: -23px;
    margin-bottom: 30px;
  }
}

</style>
